export const STRIPE_PUBLISHABLE_KEY =
  "pk_live_51HK00kKrDsn2La1OxhM7y0QabJufLpN16ltpygks2MvUky5w5qFXpHk85mfMAsmV9usxUvvilCIwNqPEbMN25WDu00jF7OwOHy";

export const isDev = process.env.NODE_ENV === "development";
